import { render, staticRenderFns } from "./ResourceCredentials.vue?vue&type=template&id=4d8e2dad&scoped=true"
import script from "./ResourceCredentials.vue?vue&type=script&lang=js"
export * from "./ResourceCredentials.vue?vue&type=script&lang=js"
import style0 from "./ResourceCredentials.vue?vue&type=style&index=0&id=4d8e2dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e2dad",
  null
  
)

export default component.exports